import { useEffect, useState } from 'react';
import { getNextDrawCountdownText } from 'utils/common';

const DrawCountdownString = ({
  date,
  initialValue,
}: {
  date: Date;
  initialValue?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState(initialValue || '');

  useEffect(() => {
    const targetDate = new Date(date);

    const update = () => {
      const drawCountdownText = getNextDrawCountdownText(targetDate);
      setTimeLeft(drawCountdownText);
    };

    update();
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval); // cleanup
  }, [date]);

  return timeLeft;
};

export default DrawCountdownString;
